import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const DateFilter = ({ setFiltersAndSort, filtersAndSort }) => {
  const [deadline, setDeadline] = useState(filtersAndSort.deadline);

  useEffect(() => {
    setDeadline(filtersAndSort.deadline);
  }, [filtersAndSort]);

  const handleSubmit = () =>
    setFiltersAndSort(prev => ({
      ...prev,
      deadline: {
        from: deadline.from,
        to: deadline.to
      }
    }));

  return (
    <>
      <Form.Label>Fecha de entrega</Form.Label>
      <div className="d-flex gap-sm-3 gap-lg-0 flex-column flex-sm-row flex-lg-column mt-0 justify-content-between align-items-sm-end align-items-lg-start">
        <div className="d-flex gap-2 gap-sm-0 gap-lg-2 w-100 flex-column flex-sm-row flex-lg-column flex-wrap">
          <Form.Group className="w-100 w-sm-50 w-lg-100 pe-0 pe-sm-1 pe-lg-0">
            <Form.Label className="fs--2">Desde</Form.Label>
            <InputGroup>
              <Form.Control
                type="date"
                value={deadline.from}
                onChange={e => {
                  setDeadline(state => ({
                    ...state,
                    from: e.target.value
                  }));
                }}
              />
            </InputGroup>
          </Form.Group>

          <Form.Group className="w-100 w-sm-50 w-lg-100 ps-0 ps-sm-1 ps-lg-0">
            <Form.Label className="fs--2">Hasta</Form.Label>

            <InputGroup>
              <Form.Control
                type="date"
                value={deadline.to}
                onChange={e => {
                  setDeadline(state => ({
                    ...state,
                    to: e.target.value
                  }));
                }}
              />
            </InputGroup>
          </Form.Group>
        </div>

        <div className="mt-2 d-flex flex-column flex-sm-row gap-2 w-100 pe-0 pe-sm-1 pe-lg-0">
          <Button
            style={{ flexGrow: 1 }}
            className="w-100 w-sm-auto"
            size="sm"
            variant="primary"
            onClick={handleSubmit}
          >
            Aplicar
          </Button>
          <Button
            style={{ flexGrow: 1 }}
            className="w-100 w-sm-auto"
            size="sm"
            variant="secondary"
            onClick={() => {
              setFiltersAndSort(prev => ({
                ...prev,
                deadline: {
                  from: '',
                  to: ''
                }
              }));
            }}
          >
            Limpiar
          </Button>
        </div>
      </div>
    </>
  );
};
DateFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  noApply: PropTypes.bool
};
